import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose, graphql } from 'react-apollo';
import { getPackagePurchaseDay } from "../../graphqlDic";
import PurchaseDay from '../../components/Scoin/PurchaseDay';

export default compose(graphql(getPackagePurchaseDay, {
    name: 'getPackagePurchaseDay'
}))(withRouter(
    connect(
        null,
        null
    )(PurchaseDay)
)
);


// WEBPACK FOOTER //
// ./src/containers/Scoin/PurchaseDay.js